import Field from "./Field";

export default function ProfileFields({ contact, onContact, agent = false }) {
  const set = (key) => (value) => onContact({ ...contact, [key]: value });
  return (
    <>
      {!agent && <div className="st-section-title">Datele tale · apar doar pe materialele tale</div>}
      <Field label="Numele tău" value={contact.salon} onChange={set("salon")} testId="contact-salon-input" />
      <Field label="Telefon / WhatsApp" value={contact.whatsapp} onChange={set("whatsapp")} testId="contact-whatsapp-input" hint={agent ? "Apare mare pe cardurile tale; saloanele te sună sau îți scriu pe WhatsApp la acest număr" : "Gol = spațiu liber pe carduri și câmp de completat în PDF"} />
    </>
  );
}
